/*global VeloxViewController, moment, VeloxWebView*/

var pdfController = new VeloxViewController({
    directory : "views/pdf",
    name: "pdf",
    container: "main",
    route: "pdf"
}) ;

function flattenCate(categories, cate, level){
    cate.level = level;
    categories.push(cate) ;
    if(cate.children){
        cate.children.forEach(function(c){
            flattenCate(categories, c, level+1) ;
        }) ;
    }
}

pdfController.prepareDataOnEnter = function(dataSearch, callback){
    this.api.api.multiread({
        category: {search: {}, orderBy: "c_code", joinFetch: [
            { otherTable: "device", type: "2many", name: "devices", joins: [
                { 
                    otherTable: "velox_binary", 
                    thisField: "d_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"device"}
                },
                {otherTable: "link_part_device", type:"2many", name: "parts", orderBy: "p_ref", joins: [
                    {otherTable: "part", flatten: true, joins: [
                        { 
                            otherTable: "velox_binary", 
                            thisField: "p_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"part"}
                        },       
                        { 
                            otherTable: "exploded"
                        }       
                    ]}
                ] },
                {otherTable: "exploded", joins:[
                    { 
                        otherTable: "velox_binary", 
                        thisField: "e_id", otherField: "table_uid", name: "binary", joinSearch: {table_name:"exploded"}
                    },
                    {   otherTable: "part_exploded_position", name:"positions", type: "2many" }
                ] },
            ]}
        ]}
    }, function(err, reads){
        if(err){ return callback(err) ;}

        var cateById = {} ;
        reads.category.forEach(function(c){
            c.children = [] ;
            cateById[c.c_code] = c ;
        }) ;
        var cateHierarchy = reads.category.filter(function(c){ return !c.c_parent;}) ;
        var childrenCate = reads.category.filter(function(c){ return c.c_parent;}) ;
        while(childrenCate.length>0){
            var cate = childrenCate.pop() ;
            cateById[cate.c_parent].children.push(cate) ;
        }

        var sortedCategories = [] ;
        cateHierarchy.forEach(function(c){
            flattenCate(sortedCategories, c, 0) ;
        }) ;

        var country = VeloxWebView.i18n.getLang().substring(0,2) ;
        sortedCategories.forEach(function(cate){
            cate.devices = cate.devices.filter(function(device){
                if(!device.d_country || device.d_country.length === 0){
                    return true ;
                }
                return device.d_country.indexOf(country) !== -1 ;
            }) ;
        }) ;


        sortedCategories.forEach(function(cate){
            cate.devices.forEach(function(device){
                var partsByRef = {} ;
                device.parts.forEach(function(p){
                    partsByRef[p.p_ref] = p ;
                }) ;
        
                if(device.exploded){
                    device.exploded.positions.forEach(function(pos){
                        if(partsByRef[pos.p_ref]){
                            partsByRef[pos.p_ref].position = pos ;
                        }
                    }) ;
                }
            });
        });


        var data = {
            categories: sortedCategories,
            firstLevelCategories: sortedCategories.filter(function(c){ return c.level === 0 ;}),
            searchResults: null,
            search: dataSearch,
            date: moment(new Date()).startOf("day").toDate()
        };

        callback(null, data) ;

    }.bind(this)) ;
} ;

pdfController.onDisplayed = function(){
    window.statusPdf = 'pdfrendered';
} ;

module.exports = pdfController ;